import EditIcon from '@mui/icons-material/Edit';
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { LocalizationProvider, DatePicker, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import StarIcon from '@mui/icons-material/Star';
import RedeemOutlinedIcon from '@mui/icons-material/RedeemOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';


const RoundedStar = ({ filled }: { filled: boolean }) => (
  <StarIcon
    sx={{
      color: filled ? '#F55446' : 'transparent',
      stroke: '#F55446',
      strokeWidth: 1,
      fontSize: 36,
    }}
  />
);

interface PaymentColumn {
    id: 'date' | 'transactionId' | 'amount' | 'paymentMethod' | 'status' | 'action';
    label: string;
    minWidth?: number;
    align?: 'left';
    format?: (value: number) => string;
  }
  
  const paymentColumns: PaymentColumn[] = [
    { id: 'date', label: 'DATE', minWidth: 170 },
    { id: 'transactionId', label: 'TRANSACTION ID', minWidth: 100 },
    {
        id: 'amount',
        label: 'AMOUNT',
        minWidth: 170,
        align: 'left',
        // format: (value: number) => value.toLocaleString('en-US'),
      },
      {
        id: 'paymentMethod',
        label: 'PAYMENT METHOD',
        minWidth: 170,
        align: 'left',
        // format: (value: number) => value.toLocaleString('en-US'),
      },
      {
        id: 'status',
        label: 'STATUS',
        minWidth: 170,
        align: 'left',
        // format: (value: number) => value.toLocaleString('en-US'),
      },
    {
      id: 'action',
      label: 'ACTION',
      minWidth: 170,
      align: 'left',
      // format: (value: number) => value.toLocaleString('en-US'),
    },
    
  ];
  
  interface PaymentData {
    date: string;
    transactionId: string;
    amount: string;
    paymentMethod: string;
    status: string;
    action: any;
  }
  
  function paymentCreateData(
    date: string,
    transactionId: string,
    amount: string,
    paymentMethod: string,
    status: string,
    action: any,
  ): PaymentData {
    return { date, transactionId, amount, paymentMethod, status, action };
  }
  
  const paymentRows = [
    paymentCreateData('Oct 19. 2025', 'ch_INzXYZ2eZvKY102C', "$125.00", "Visa****0144", "In Progress", 
    <>
    <IconButton sx={{ backgroundColor: '#222D38', borderRadius: '0px', borderBottomLeftRadius: '5px', borderTopLeftRadius: '5px', marginRight: '2px' }}><VisibilityOutlinedIcon /></IconButton>
        <IconButton sx={{ backgroundColor: '#222D38', borderRadius: '0px', marginRight: '2px' }}><FileDownloadOutlinedIcon /></IconButton>
        <IconButton sx={{ backgroundColor: '#222D38', borderRadius: '0px', marginRight: '2px', borderBottomRightRadius: '5px', borderTopRightRadius: '5px'}}><DeleteOutlineOutlinedIcon /></IconButton>
      </>),
    paymentCreateData('Sep 1, 2025', 'ch_GtAQR4s3wMOTK221', "$125.00", "Visa****0144", "Completed", 
        <>
        <IconButton sx={{ backgroundColor: '#222D38', borderRadius: '0px', borderBottomLeftRadius: '5px', borderTopLeftRadius: '5px', marginRight: '2px' }}><VisibilityOutlinedIcon /></IconButton>
            <IconButton sx={{ backgroundColor: '#222D38', borderRadius: '0px', marginRight: '2px' }}><FileDownloadOutlinedIcon /></IconButton>
            <IconButton sx={{ backgroundColor: '#222D38', borderRadius: '0px', marginRight: '2px', borderBottomRightRadius: '5px', borderTopRightRadius: '5px'}}><DeleteOutlineOutlinedIcon /></IconButton>
          </>),
  ];

  
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
    ...theme.applyStyles('dark', {
      backgroundColor: '#0DA85A',
    }),
  },
}));

const RateMyStayContent = () => {
  const [hover, setHover] = useState(0);  // hover temporary rating
  const [rating, setRating] = useState(0); // clicked rating
  const [extendDialogOpen, setExtendDialogOpen] = useState(false);
  const [message, setMessage] = useState("");   // current textarea

  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [selectedExtension, setSelectedExtension] = useState<'4hours' | '8hours' | 'fullday' | null>(null);
  const [cancelReason, setCancelReason] = useState('');
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
    open: false,
    message: '',
    severity: 'success'
  });
  
  const [value, setValue] = useState<Date | null>(new Date("2025-06-10"));
  const [calenderOpen, setCalenderOpen] = useState(false);
  const [checkOutValue, setCheckOutValue] = useState<Date | null>(new Date("2025-06-10"));
  const [checkOutCalenderOpen, setCheckOutCalenderOpen] = useState(false);
  const [time, setTime] = useState<Date | null>(new Date());  // Must be Date type
  const [openTime, setOpenTime] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
    <Box sx={{ background: '#151A23', color: '#fff', marginTop: "64px", mb:"-80px", borderTop:"1px solid #2C353F", borderBottom:"1px solid #2C353F", padding: "17px 31px",
      "& svg":{
        fontSize: "24px",
        display: "block",
      }
     }}>
        <Typography sx={{ fontSize: 18, fontWeight: "semibold", color: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        Rate Your Stay
        </Typography>
        </Box>
    <Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, background: '#151A23', minHeight: '100vh', color: '#fff', marginTop: 10 }}>
      {/* Header */}
      
      <Paper sx={{ boxShadow: 'none', mb: 3, background: '#131A21', borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }} elevation={4}>
      <Typography variant="h6" fontWeight="bold" fontSize={30} sx={{py:0}}>How was your stay at Botel Marina?</Typography>
      <span style={{ display: 'flex', alignItems: 'center'}}>
        <img src="/icons/calender-icon.svg" alt="calendar icon" style={{ height: 22, marginRight:"8px"}} />
        <b>April 15-18, 2025</b>
        </span>
          {/* <Typography variant="h6" fontWeight="bold" >{booking?.botel?.name}</Typography> */}
      </Paper>

      <Paper sx={{ p: 4, background: '#1F262C', borderRadius: 3, mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }} elevation={4}>
       <Box>
        <img src="/images/dummy-img.png" alt="botel image" style={{ width: 80, height: 80, borderRadius: 10 }} />
        </Box>
      <Box>
      <Typography variant="h6" fontWeight="bold" fontSize={24} sx={{py:0}}>Botel one hawthorne atlanta</Typography>
      <Typography variant="h6" fontWeight="bold" fontSize={18} sx={{py:0}}>Atlanta GA</Typography>
          {/* <Typography variant="h6" fontWeight="bold" >{booking?.botel?.name}</Typography> */}
      </Box>
      </Paper>

      {/* Refund Tracking */}
      <Grid container spacing={2} sx={{ p: 2,pt:4, pb:0,background: '#1F262C', borderRadius: 3, borderBottomLeftRadius: "0px", borderBottomRightRadius: "0px" }}>
        <Grid size={{ xs: 12, md: 6 }}>
        <Paper sx={{ boxShadow: 'none', py:"82px", mb: 3, background: '#131A21', borderRadius: 3, width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}} elevation={4}>
          <Typography sx={{ pb: "20px" }} fontSize={30} variant="body2">Rate Your Expeirence</Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
      {[1, 2, 3, 4, 5].map((star) => {
        const isFilled = star <= (hover || rating);

        return (
          <IconButton
            key={star}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
            onClick={() => setRating(star)}
            disableRipple
            sx={{
              width: 35,
              height: 34,
              padding: 0,
            }}
          >
            <RoundedStar filled={isFilled} />
          </IconButton>
        );
      })}
    </Box>
        </Paper>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography fontSize={16} sx={{mb: 2.5}}>Your review</Typography>
        <TextField
        multiline
        minRows={7}
        fullWidth
        placeholder="Share your experience with other travelers..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        sx={{
          mb: 2,
          borderRadius: "10px",
          backgroundColor: '#131A21',
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#2C353F",
              borderWidth: "2px",
            },
            "&:hover fieldset": {
              borderColor: "#2C353F",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#2C353F",
            },
          },
        }}
      />
        </Grid>
      </Grid>

<Box sx={{background: '#1F262C', borderRadius: "12px", p: 2,pb:4,pt:0, borderTopLeftRadius: "0px", borderTopRightRadius: "0px"}}>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', gap: 2, background: '#3C30AE', borderRadius: "12px", p: 2 }}>
         
         <Box>
          <Alert 
            icon={<RedeemOutlinedIcon sx={{ fontSize: 68, color: 'white' , stroke: "#3C30AE"}} />} 
            severity="info" 
            sx={{ background:  '#3C30AE' , color: '#fff', borderRadius: "12px", alignItems: 'center', fontWeight: 500, p: 2, display: 'flex' }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 30 }}>
            Upgrade Your Botel Experience
               </Typography>
            <Typography sx={{ color: "white", fontWeight: 500, fontSize: 18 }}>
            Get access to premium features and boost your hosting revenue
              </Typography>
              
            
            </Box>
          </Alert>
          </Box>
          <Button variant="contained" color="primary" sx={{color:"#3C30AE",backgroundColor:"#fff",  borderRadius: "10px",  fontSize: 16, fontWeight: 700, py: 1.5 , mr: 3}}>
          +5 points
          </Button>
        </Box>
        <Box sx={{mt:"20px", display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', gap: 2, backgroundColor: '#131A21', borderRadius: "12px", p: 2 }}>
          <Box>
            <Typography fontSize={18} sx={{ display: 'flex', alignItems: 'center', gap: 1}}>
           <HelpOutlineOutlinedIcon sx={{color:"gray"}}/> Your review will be published after admin approval
            </Typography>
          </Box>
          <Button variant="contained" color="primary" sx={{color:"white",backgroundColor:"#2156C4",  borderRadius: "10px",  fontSize: 16, fontWeight: 700, py: 1.5 , mr: 3}}>
          submit review
          </Button>
        </Box>
        </Box>
    </Box>
    </>
  );
};

export default RateMyStayContent; 